export default function V_1ServiceContent() {
  return (
    <div className="service-context">
      <section className="context-part">
        <h3>제 1장 총칙</h3>
        <div>
          <h4>제 1조 목적</h4>
          <p>
            본 약관은 회원이 주식회사 이든파이낸셜 (이하 “회사”라 함)에서
            제공하는 이든든 서비스(이하 “서비스”라 하며, 추후 서비스 명은 변경될
            수 있음)를 이용함에 있어 회사와 회원간 또는 회원 간의 권리, 의무 및
            책임사항, 서비스 이용조건 및 절차 등 기본적인 사항을 규정함을
            목적으로 합니다.
          </p>
        </div>
        <div>
          <h4>제 2조 용어의 정의</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
            </div>
            <ul>
              <li>
                (1) "회원" 라 함은 회사가 제공하는 서비스에 접속하여 이 약관에
                따라 회사와 이용계약을 체결하고 회사가 제공하는 서비스를
                이용하는 모든 이용자를 말합니다.
              </li>
              <li>
                (2) "서비스"라 함은 회사의 웹사이트를 통해 회원에게 제공하는
                서비스를 통칭하며, 회원의 동의 하에 수집하여 "재무관련정보"에
                따라 금융상품 등의 정보를 제공하는 서비스를 의미합니다.
              </li>
              <li>
                (3) "제휴사"란 회사와 계약을 체결하고 이든든 웹 서비스 및 회사의
                서비스를 이용하여 상품을 판매하거나 서비스를 제공하는 사업자를
                말합니다.
              </li>
              <li>
                (4) "전자금융거래"라 함은 회사가 전자적 장치를 통하여 금융상품
                및 서비스를 제공(이하 "전자금융업무"라 함)하고, 회원이 회사의
                종사자와 직접 대면하거나 의사소통을 하지 아니하고 자동화된
                방식으로 이를 이용하는 거래를 말합니다.
              </li>
              <li>
                (5) “대출모집서비스”라 함은 금융회사가 회사에 위탁한 범위 내의
                대출상품 관련 서비스를 이든든 웹 서비스에서 이용할 수 있도록
                회사가 회원에게 제공하는 서비스를 말합니다.
              </li>
              <li>
                (6) “위탁금융사”란 회사에 대출모집서비스 업무를 위탁한
                금융회사를 말합니다.
              </li>
              <li>
                (7) “모집서비스 대상 상품”이란 위탁금융사가 운영하는 금융상품 중
                회사에게 업무를 위탁한 개별 상품을 말합니다.
              </li>
            </ul>
            <div className="text-item">
              <span>2.</span>
              <p>
                본 약관에서 사용하는 용어 중 제1항에서 정하지 아니한 것은 관련
                법령에서 정하는 바에 따르며, 그 외에는 일반적인 상관례에
                따릅니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 3조 이용약관의 명시 및 효력</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 회원이 알 수 있도록 서비스가 제공되는 웹사이트에 본
                약관을 게시합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 서비스를 이용하고자 하는 자가 본 약관의 내용을 알 수
                있도록 작성하고 본 약관에 동의하기에 앞서 본 약관에 정하여져
                있는 애용 중 계약 해지, 회사의 면책사항 등 중요 내용을 회원이 알
                수 있도록 합니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                회사는 『개인정보 보호법』, 『신용정보의 이용 및 보호에 관한
                법률』 등 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수
                있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>4.</span>
              <p>
                회사가 본 약관을 개정할 경우에는 개정 약관의 적용일자 및
                개정사유를 명시하여 현행약관과 함께 개정 약관의 적용일자 7일
                전에 회원에게 공지합니다. 단, 회원의 권리, 의무에 중대한 영향을
                주는 변경의 경우에는 적용일자 30일 전에 공지하도록 합니다.
              </p>
            </div>
            <div className="text-item">
              <span>5.</span>
              <p>
                회원은 변경된 약관에 대해 거부할 권리가 있으며, 변경된 약관이
                공지된 지 15일 이내에 거부의사를 표명할 수 있습니다. 회원이
                변경된 약관을 거부하는 경우 본 서비스 제공자인 회사는 회원에게
                사전통지 후 당해 회원과의 계약을 해지할 수 있습니다. 만약,
                회원이 해당 기간 내에 의사를 표시하지 않거나, 전항에 따라 시행일
                이후에 서비스를 이용하는 경우에 변경된 약관에 동의한 것으로
                간주합니다.
              </p>
            </div>
            <div className="text-item">
              <span>6.</span>
              <p>
                회사는 회원이 회사와 본 약관의 내용에 관하여 질의 및 응답을 할
                수 있도록 조치를 취합니다.
              </p>
            </div>
            <div className="text-item">
              <span>7.</span>
              <p>
                회원이 개정약관의 적용에 동의하지 않는 경우 회사 또는 회원은
                서비스 이용계약을 해지할 수 있습니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 4조 서비스의 종류와 내용</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>회사는 회원에게 다음 각 호의 서비스를 제공합니다.</p>
            </div>
            <ul>
              <li>
                (1) 회원이 동의한 개인(신용)정보를 수집하여 열람하도록 하는 조회
                서비스
              </li>
              <li>
                (2) 회사가 개발하거나 제휴사 등 다른 회사와의 협력을 통해
                제공하는 서비스
              </li>
              <li>
                (3) 금융상품별 상품 정보, 혜택 정보, 이벤트 정보 등의 컨텐츠
                제공 서비스
              </li>
              <li>(4) 맞춤형 금융 상품 및 가입 링크 제공 서비스</li>
              <li>
                (5) 기타 본 조 각 호의 서비스에 부수하거나 다른 회사와의 제휴를
                통해 제공되는 서비스
              </li>
            </ul>
            <div className="text-item">
              <span>2.</span>
              <p>
                서비스의 구체적인 내용은 회사가 정하며, 회원은 이든든 웹
                서비스를 통하여 그 내용을 확인할 수 있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                서비스의 종류와 내용은 관련 법령, 회사 및 제휴사의 정책 변화에
                따라 달라질 수 있습니다.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="context-part">
        <h3>제 2장 서비스 이용 및 이용계약</h3>
        <div>
          <h4>제 5조 서비스의 이용</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회원은 이든든 웹 서비스를 이용하여 회사의 서비스를 이용할 수
                있습니다. 단, 서비스의 종류에 따라 그 이용을 위하여 본인 확인 및
                실명 확인, 접근매체를 통한 인증, 개인(신용)정보 수집이용 동의 등
                회사 또는 제휴사에 대한 회원의 개인(신용)정보의 제공이
                필요합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 특정 서비스의 제공을 위하여 회원에게 본 약관 이외에 개별
                약관에 대한 동의, 정보 수집 및 이용 동의 등 절차의 이행을 추가로
                요청할 수 있습니다. 이러한 절차가 완료되지 않는 경우 해당 회원은
                특정 서비스의 전부 또는 일부를 이용하지 못할 수 있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                회원은 이든든 웹 서비스를 연중무휴 1일 24시간 이용할 수
                있습니다. 다만, 이용시간은 회사의 사정에 따라 변경될 수 있으며,
                시스템 점검 등의 사유로 일시적으로 서비스가 제공되지 않을 수
                있습니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 6조 제휴사와의 제휴</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 서비스의 제공을 위해 신용정보회사, 금융기관 등 다른
                회사와 제휴할 수 있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                서비스 제공에 필요한 제휴사 제공 정보를 이용하기 위하여 회원의
                제휴사 약관에 대한 동의가 필요할 수 있습니다. 제휴사가 제공하는
                정보 이용에 관해서는 회원과 제휴사 사이에 제휴사 약관이
                적용됩니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                제휴사가 제공하는 정보와 그에 기반한 서비스의 경우 회사는 정보의
                최신성, 정확성 등을 보장하지 않으며, 제휴사의 사정으로 정보
                제공이 중단되는 경우 서비스의 전부 또는 일부의 이용이 불가능할
                수 있습니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 7조 서비스의 중단 및 변경</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 운영상, 경영상, 기술상의 필요가 있거나 제휴사와의
                계약관계에 따라 서비스의 전부 또는 일부를 수시로 변경할 수
                있습니다. 서비스 변경이 중대한 경우, 회사는 사전에 그 내용을
                이든든 웹 서비스 내에 공지합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 다음 각 호의 어느 하나의 경우에는 서비스의 전부 또는
                일부를 중단할 수 있습니다.
              </p>
            </div>
            <ul>
              <li>- 통신, 전력 등의 공급이 중단되는 불가피한 경우</li>
              <li>
                - 금융회사, 신용정보조회기관, 통신사 등 관계 기관의 서비스
                점검시간
              </li>
              <li>
                - 정보통신설비의 보수점검, 증설, 교체, 이전 등의 유지관리 업무를
                수행하기 위해 필요한 경우
              </li>
              <li>
                - 제반 설비의 장애 또는 과도한 트래픽 발생 등 정상적인 서비스
                이용에 지장이 있는 경우
              </li>
              <li>
                - 제휴사와의 계약 종료 등 회사의 사정 변경으로 서비스를 유지할
                수 없는 경우
              </li>
              <li>
                - 회사가 운영상, 경영상, 기술상 필요에 의하여 서비스의 중단이
                불가피하다고 판단할 경우
              </li>
              <li>
                - 기타 천재지변, 폭동, 전쟁, 테러, 국가비상사태 등 불가항력적
                사유가 있는 경우
              </li>
            </ul>
            <div className="text-item">
              <span>3.</span>
              <p>
                회사는 제 1항, 제 2 항 에 따라 서비스의 전부 또는 일부를
                변경하거나 중단 또는 종료하는 경우 그 사유와 내용을 사전에
                통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가
                있는 경우에는 사후에 알릴 수 있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>4.</span>
              <p>
                회사는 본 약관 및 관련 법령에 특별한 규정이 없는 한 서비스의
                변경, 중단, 종료로 인하여 회원이 입은 손해에 대해 아무런 책임을
                지지 않습니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 8조 맞춤형 광고 안내</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 회원에게 유용한 정보를 안내하기 위해 맞춤형 광고를 제공할
                수 있으며, 맞춤형 광고를 위해 최소한의 정보만 수집•처리합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 회원에게 적절한 맞춤형 광고를 제공하기 위해 다음 정보를
                수집•처리할 수 있습니다.
              </p>
            </div>
            <ul>
              <li>- 광고 식별정보(ADID)</li>
              <li>- 이든든 웹 서비스 방문기록 또는 활동기록</li>
              <li>- 기타 이든든 웹 서비스 이용에 대한 행태정보</li>
            </ul>
            <div className="text-item">
              <span>3.</span>
              <p>
                맞춤형 광고를 위해 수집한 정보는 제3자에게 제공하거나,
                다른정보와 결합하여 사용하지 않으며, 일반 개인(신용)정보와
                동일한 보안 기준을 가지고 안전하게 관리합니다.
              </p>
            </div>
            <div className="text-item">
              <span>4.</span>
              <p>
                회사는 맞춤형 광고에 대해 만 20세 미만을 회원의 정보를 일체
                처리하지 않고, 광고를 제공하지 않습니다.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="context-part">
        <h3>제 3장 계약 당사자의 의무 등</h3>
        <div>
          <h4>제 9조 회사의 의무</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 관련 법령과 본 약관에서 금지하거나 미풍양속에 반하는
                행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기
                위하여 최선을 다하여 노력합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 회원이 안전하게 서비스를 이용할 수 있도록
                개인(신용)정보보호를 위한 보안시스템을 갖추고 임직원을 교육 및
                관리하며, 관련 법령이 정하는 기술적 보안 기준을 준수합니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                회사는 서비스 이용과 관련하여 회원으로부터 제기된 의견이나
                불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. 회원이
                제기한 의견이나 불만사항에 대해서는 회원에게 처리과정 및 결과를
                전달합니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 10조 회원의 의무</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회원은 관련 법령, 본 약관 및 회원이 동의한 개별 약관, 서비스
                이용안내, 서비스 상에 공지한 주의사항, 회사가 서비스 이용과
                관련하여 회원에게 통지하는 사항 등을 준수하여야 하며, 이를
                위반하거나 이행하지 아니하여 발생하는 모든 손실, 손해에 대하여
                책임을 부담합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회원은 서비스와 관련하여 명확한 정보를 입력하여야 하며, 회원은
                자신이 입력한 정보와 관련하여 발생하는 제반 문제에 대한 모든
                책임을 부담합니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                회원은 자신의 개인(신용)정보, 계정정보, 인증서 정보, 이용기기
                등(이하 포괄하여 ‘서비스 이용매체’)을 타인에게 제공, 누설하지
                아니하며, 타인이 회원의 서비스 이용매체를 무단으로 사용하여
                서비스를 이용하는 일이 없도록 관리하여야 합니다.
              </p>
            </div>
            <div className="text-item">
              <span>4.</span>
              <p>
                회원은 서비스 이용권한 및 기타 이용 계약상 지위를 타인에게
                양도할 수 없습니다.
              </p>
            </div>
            <div className="text-item">
              <span>5.</span>
              <p>
                회원은 자신의 명의가 도용되거나 제3자에게 부정하게 사용된 것을
                인지한 경우 즉시 그 사실을 회사에 통보하여야 합니다.
              </p>
            </div>
            <div className="text-item">
              <span>6.</span>
              <p>회원은 다음 각 호의 행위를 하여서는 안됩니다.</p>
            </div>
            <ul>
              <li>
                - 회사가 제공하는 서비스 이용방법에 의하지 아니하고 비정상적인
                방법으로 서비스를 이용하거나 시스템에 접근하는 행위
              </li>
              <li>
                - 회사가 금지한 정보(컴퓨터 소프트웨어, 하드웨어, 전기통신장비의
                정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스
                기타 다른 컴퓨터 코드)의 송수신, 게시, 유포하는 행위
              </li>
              <li>
                - 회사가 게시한 정보의 무단 변경 또는 회사가 정한 정보 이외의
                정보(컴퓨터 프로그램 등) 등의 송신 또는 게시하는 행위
              </li>
              <li>
                - 타인의 개인(신용)정보 등을 도용하여 회사가 제공하는 서비스를
                이용하는 행위
              </li>
              <li>
                - 회사 및 기타 제3자의 저작권 등 지적재산권에 대한 침해행위
              </li>
              <li>
                - 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
              </li>
              <li>- 회사의 임직원, 운영자 등 기타 관계자를 사칭하는 행위</li>
              <li>
                - 회사가 제공하는 서비스를 이용하여 얻은 회사의 정보를 회사의
                사전 동의 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위
              </li>
              <li>- 회사의 시스템을 해킹하거나 해킹에 이용하는 일체의 행위</li>
              <li>- 기타 불법적이거나 부당한 행위</li>
            </ul>
          </div>
        </div>
        <div>
          <h4>제 11조 회원에 대한 통지</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사가 회원에게 통지를 하는 경우 회원이 지정한 e-mail,
                SMS/LMS/MMS 메시지, 모바일 어플리케이션 Push 알림 등으로 할 수
                있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 회원 전체에 대한 통지의 경우 7일간 서비스 공지사항 또는
                웹사이트에 게시함으로써 제1항의 통지를 갈음할 수 있습니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 12조 권리의 귀속</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                서비스 및 서비스 내 회사가 제작한 컨텐츠 및 이에 부속한 컨텐츠
                등에 대한 저작권, 기타 지적재산권은 회사에 귀속됩니다. 단,
                제3자와의 업무제휴계약에 따라 제공받은 저작물 등은 제외합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 회사가 정한 이용조건에 따라 서비스와 관련하여 회원에게
                이용할 수 있는 권리만을 부여하며, 회원은 이를 양도, 판매, 담보
                제공하는 등 일체의 처분행위를 할 수 없습니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                회원은 서비스의 이용 과정에서 얻은 정보를 가공, 제공, 판매하는
                등 영리 목적으로 이용하거나 제3자에게 제공할 수 없습니다.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="context-part">
        <h3>제 4장 계약 해제, 해지 및 서비스 이용제한</h3>
        <div>
          <h4>제 13조 회원의 계약해지, 이용계약의 제한 등</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 회원이 다음 각 호의 어느 하나에 해당하는 행위를 하였을
                경우 이용계약 신청의 결정을 유보하거나, 이용계약을 해지 또는
                해당 회원의 서비스의 이용을 중단시킬 수 있습니다.
              </p>
            </div>
            <ul>
              <li>- 타인의 명의로 사용 등 허위로 이용신청을 하는 경우</li>
              <li>- 이미 가입된 회원이 중복하여 이용신청을 하는 경우</li>
              <li>
                - 이용신청 사항을 누락하거나 오 기입하여 이용신청을 하는 경우
              </li>
              <li>- 서비스 운영을 고의로 방해한 경우</li>
              <li>- 공공질서 및 미풍양속에 저해되는 내용을 유포시킨 경우</li>
              <li>- 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우</li>
              <li>
                - 서비스의 안정적 운영을 방해할 목적으로 바이러스 프로그램,
                다량의 광고성 정보 등을 전송하는 경우
              </li>
              <li>
                - 본 약관 및 기타 회사가 정한 제반 사항을 위반하여 신청하는 경우
              </li>
            </ul>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 회원이 본 약관에서 정한 회원의 의무를 위반한 경우에는
                제4항에 따른 사전 통보 후 계약을 해지할 수 있으며, 회원은
                서비스의 사용권한을 상실하고 이로 인한 환불 및 손해배상을 청구할
                수 없습니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                회사가 이용계약을 해지하는 경우 회사는 회원에게 e-mail,
                SMS/LMS/MMS 메시지 또는 이에 준하는 방법으로 다음 사항을 사전
                통보합니다.
              </p>
            </div>
            <ul>
              <li>- 해지일</li>
              <li>- 해지사유</li>
            </ul>
            <div className="text-item">
              <span>4.</span>
              <p>
                이용계약해지로 인해 발생한 불이익에 대한 책임은 회원 본인에게
                있으며, 이용계약이 종료되면 회사는 회원에게 부가적으로 제공한
                각종 혜택을 회수할 수 있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>5.</span>
              <p>
                회원이 임의로 서비스를 해지한 후 재차 이용신청을 하는 경우
                회사는 심사를 거쳐 당해 회원에 대하여 일정기간 재가입을 제한할
                수 있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>6.</span>
              <p>
                이용계약을 해지할 경우, 관련 법령 및 회사의 개인정보처리방침에서
                정한 바에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 해지
                후 즉시 회원의 모든 데이터는 지체 없이 파기됩니다.
              </p>
            </div>
            <div className="text-item">
              <span>7.</span>
              <p>
                회원은 회사의 이용제한 조치 등에 대하여 이의신청을 할 수 있으며,
                회사는 회원의 이의 사유가 정당하다고 인정되는 경우 즉시 회원의
                서비스 이용을 재개하여야 합니다.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="context-part">
        <h3>제 5장 개인정보 보호 및 관리</h3>
        <div>
          <h4>제 14조 개인(신용)정보 보호 및 처리</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 관련 법령이 정하는 바에 따라 회원의 개인(신용)정보를
                보호하기 위해 노력합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회원의 개인(신용)정보를 처리하기 위해 사전에 처리목적, 제공목적
                등을 명시하며, 회원의 동의없이 처리, 제공 또는 목적외로 활용하지
                않습니다. 다만, 다음의 경우에는 예외로 합니다.
              </p>
            </div>
            <ul>
              <li>
                - 법령에서 개인(신용)정보의 이용과 제3자 제공을 허용하고 있는
                경우
              </li>
              <li>- 회원임을 확인 할 수 없도록 통계적 자료로 활용하는 경우</li>
            </ul>
            <div className="text-item">
              <span>3.</span>
              <p>
                회원이 동의하는 경우 회사는 회원의 개인(신용)정보를 회사의 다른
                업무에 이용하거나 제휴 서비스 제공기관 등 제3자에게 제공할 수
                있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>4.</span>
              <p>
                회사에서 제공하는 서비스 및 개별 서비스를 제외한 단순 링크로
                제공되는 제3자 제공의 서비스에 대하여는 회사의
                개인정보처리방침이 적용되지 않습니다.
              </p>
            </div>
            <div className="text-item">
              <span>5.</span>
              <p>
                회사는 회원이게 필요하다고 생각되는 유용한 정보(광고를 포함)를
                제공할 수 있습니다. 회원은 해당 정보의 수신을 거부할 수
                있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>6.</span>
              <p>
                회사의 개인(신용)정보의 보호 및 이용에 대한 사항은 회사의
                개인정보처리방침을 통해 안내 드립니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 15조 회원정보의 수집</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회원은 회사에게 정보를 제공하고자 하는 경우 사실대로 제공하여야
                합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 이용계약을 위하여 회원이 제공 동의한 정보 외에도 수집
                또는 처리목적을 밝혀 회원의 정보를 수집할 수 있으며, 관계 법령에
                의해 회원의 동의가 필요한 경우에는 동의를 받습니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                회사가 정보수집 및 처리를 위하여 회원의 동의를 받은 경우, 회사는
                수집 및 처리하는 개인정보의 항목 및 수집방법, 수집목적 및
                처리목적, 개인정보의 처리 및 보유기간, 제3자에 대한 정보제공
                사항(제공받는 자, 제공받는 자의 이용목적, 제공정보의 항목, 보유
                및 이용기간)을 개인정보 처리방침으로 미리 명시하고 고지합니다.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="context-part">
        <h3>제 6장 손해배상 등</h3>
        <div>
          <h4>제 16조 손해배상</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사와 회원은 본 약관의 규정을 위반하거나 기타 불법행위를 하여
                상대방에게 손해를 입힌 경우 그 손해 발생에 귀책사유가 있는
                당사자는 그 손해를 배상하여야 합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회원이 서비스를 이용하면서 불법행위를 하거나 본 약관의 규정을
                위반하는 행위를 하여 회사가 제3자로부터 손해배상 청구를 비롯한
                각종 이의제기를 받는 경우 해당 회원은 자신의 책임과 비용으로
                회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 그로 인하여
                회사에 발생한 손해를 배상하여야 합니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 17조 회사의 면책</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를
                제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는
                책임을 지지 않습니다.
              </p>
            </div>

            <div className="text-item">
              <span>3.</span>
              <p>
                제휴사와 계약을 통하여 제휴사가 회원에게 제공하는 정보 및
                서비스는 해당 제휴사가 회원에게 제공하는 것이며, 제휴사와 회원
                사이에 이루어지는 계약은 계약의 당사자인 제휴사와 회원 각각의
                책임하에 이루어집니다. 회사는 회사의 귀책사유가 없는 한 이와
                관련된 법적 분쟁에 개입하거나 책임을 지지 않습니다.
              </p>
            </div>
            <div className="text-item">
              <span>4.</span>
              <p>
                회사는 회원 상호간, 회원과 제휴사 상호간 또는 회원과 제3자
                상호간에 발생한 분쟁에 대해서는 개입할 의무가 없으며, 회사에
                귀책사유가 없는 한 이로 인한 손해를 배상할 책임이 없습니다.
              </p>
            </div>
            <div className="text-item">
              <span>5.</span>
              <p>
                회원이 자신의 개인(신용)정보, 계정정보, 인증서 정보, 이용기기 등
                서비스 이용매체를 타인에게 제공, 누설하거나, 회원의 관리 소홀로
                유출되어 발생하는 피해에 대해서 회사는 책임을 지지 않습니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 18조 분쟁의 해결</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우,
                회사와 회원은 분쟁의 해결을 위해 성실히 협의합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                제1항의 협의에서도 분쟁이 해결되지 않아 소송이 제기되는 경우,
                대한민국 법률을 준거법으로 하며 관할법원은 민사소송법에 따라
                정합니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 19조 준거법 및 재판관할</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수
                있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사가 본 약관을 변경하고자 하는 경우에는 적용일자 및 변경사유를
                명시하여 적용일자 7일 전부터 적용일자 전일까지 공지합니다.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="context-part">
        <h3>제 7장 약관의 변경 및 이의신청 등</h3>
        <div>
          <h4>제 20조 약관의 변경</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수
                있습니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사가 본 약관을 변경하고자 하는 경우에는 적용일자 및 변경사유를
                명시하여 적용일자 7일 전부터 적용일자 전일까지 이든든 웹 서비스
                등을 통해 공지합니다. 다만, 회원에게 불리하거나 중요한 사항을
                변경하는 경우에는 적용일자 30일 이전에 게시하고 회원에게 개별
                통지합니다.
              </p>
            </div>
            <div className="text-item">
              <span>3.</span>
              <p>
                회사가 제1항에 따라 약관 변경 내용을 게시하거나 통지를 하는
                경우에는 “회원은 약관의 변경 내용이 게시되거나 통지가 발송된
                날로부터 변경 약관의 적용일자 전까지 계약을 해지할 수 있으며,
                변경 약관의 적용일자 전까지 계약 해지의 의사표시를 하지 않은
                경우에는 약관의 변경에 동의한 것으로 본다.”라는 취지의 내용을
                통지하여야 합니다.
              </p>
            </div>
            <div className="text-item">
              <span>4.</span>
              <p>
                회원은 약관의 변경 내용이 게시되거나 통지가 발송된 날로부터 변경
                약관의 적용일자 전까지 본 이용계약을 해지할 수 있고, 변경 약관의
                적용일자 전까지 계약 해지의 의사표시를 하지 않은 경우에는 약관의
                변경에 동의한 것으로 간주합니다.
              </p>
            </div>
            <div className="text-item">
              <span>5.</span>
              <p>
                회원이 개정약관의 내용에 동의하지 않는 경우 회사는 해당 회원에
                대하여 개정약관의 내용을 적용할 수 없습니다. 다만, 회사가
                개정약관에 부동의한 회원에게 기존 약관을 적용할 수 없는 특별한
                사정이 있는 경우에는 회사는 해당 회원과의 이용계약을 해지할 수
                있습니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 21조 준용규정</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회사는 특정 서비스에 적용될 사항의 규정을 위해 개별약관을
                사용하거나 이용정책을 구분하여 운영할 수 있으며, 본 약관에서
                정한 내용이 다른 약관과 충돌하는 경우 개별약관이 우선합니다.
              </p>
            </div>
            <div className="text-item">
              <span>2.</span>
              <p>
                본 약관에서 정하지 아니한 사항은 관련 법령이 우선 적용됩니다.
              </p>
            </div>
          </div>
        </div>
        <div>
          <h4>제 22조 이의신청</h4>
          <div className="context-text">
            <div className="text-item">
              <span>1.</span>
              <p>
                회원은 서비스 이용과 관련하여 회사에 이의가 있는 경우 아래의
                방법으로 이의를 제기할 수 있습니다.
              </p>
            </div>
            <ul>
              <li>이메일 : privacy@edencorp.kr</li>
              <li>이든든 웹 서비스 {">"} 카카오채널 이든파이낸셜</li>
            </ul>
            <div className="text-item">
              <span>2.</span>
              <p>
                회사는 영업일 15일 이내에 이에 대한 조사 또는 처리 결과를
                회원에게 안내합니다. 단, 회사는 회신 기간 내에 처리할 수 없는
                정당한 사유가 있을 때에는 회원에게 그 사유를 알리고 처리를
                연기할 수 있으며, 그 사유가 소멸하면 지체 없이 처리합니다.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="service-end-text">
        <p>부칙</p>
        <p> 본 약관은 2022년 06월 07일부터 적용됩니다.</p>
      </div>
    </div>
  );
}
